<footer class="site-footer">
  <section class="site-footer__cta">
    <p class="site-footer__eyebrow">{{ 'footer.planEyebrow' | translate }}</p>
    <h2 class="site-footer__heading">{{ 'footer.ctaHeading' | translate }}</h2>
    <p class="site-footer__description">
      {{ 'footer.ctaDescription' | translate }}
    </p>
    <div class="site-footer__cta-actions">
      <a routerLink="/book" class="site-footer__btn site-footer__btn--primary">
        {{ 'common.bookNow' | translate }}
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">
          <path d="M5 12h14M13 6l6 6-6 6" />
        </svg>
      </a>
      <a routerLink="/rooms" class="site-footer__btn site-footer__btn--secondary">{{ 'common.viewRooms' | translate }}</a>
    </div>
  </section>

  <div class="site-footer__main">
    <div class="site-footer__grid">
      <div class="site-footer__brand">
        <a routerLink="/home" class="site-footer__brand-link">
          <span class="site-footer__logo" aria-hidden="true">M</span>
          <span class="site-footer__brand-name">{{ 'common.brandName' | translate }}</span>
        </a>
        <p class="site-footer__brand-text">
          {{ 'footer.brandDescription' | translate }}
        </p>
        <div class="site-footer__social">
          @for (social of socialLinks; track social.platform) {
            <a [href]="social.href" class="site-footer__social-link" [attr.aria-label]="social.labelKey | translate" target="_blank" rel="noopener noreferrer">
              @switch (social.platform) {
                @case ('instagram') {
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
                    <rect x="2" y="2" width="20" height="20" rx="5" />
                    <circle cx="12" cy="12" r="4" />
                    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none" />
                  </svg>
                }
                @case ('facebook') {
                  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M14 8h3V4h-3c-2.8 0-5 2.2-5 5v2H6v4h3v6h4v-6h3.1L17 11h-4V9c0-.6.4-1 1-1z" />
                  </svg>
                }
                @default {
                  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                    <path d="M18.9 3H21l-6.6 7.5L22 21h-5.5l-4.3-5.6L7 21H3l7.1-8.1L2 3h5.6l3.9 5.1L18.9 3zm-1.9 16h1.7L7.5 5H5.6L17 19z" />
                  </svg>
                }
              }
            </a>
          }
        </div>
      </div>

      <div class="site-footer__column">
        <h3 class="site-footer__column-title">{{ 'footer.explore' | translate }}</h3>
        <ul class="site-footer__links">
          @for (link of exploreLinks; track link.route) {
            <li>
              <a [routerLink]="link.route">{{ link.labelKey | translate }}</a>
            </li>
          }
        </ul>
      </div>

      <div class="site-footer__column">
        <h3 class="site-footer__column-title">{{ 'footer.information' | translate }}</h3>
        <ul class="site-footer__links">
          @for (link of informationLinks; track link.route) {
            <li>
              <a [routerLink]="link.route">{{ link.labelKey | translate }}</a>
            </li>
          }
        </ul>
      </div>

      <div class="site-footer__column">
        <h3 class="site-footer__column-title">{{ 'footer.stayInTouch' | translate }}</h3>
        <ul class="site-footer__contact">
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
              <path d="M12 21s7-4.5 7-11a7 7 0 1 0-14 0c0 6.5 7 11 7 11z" />
              <circle cx="12" cy="10" r="2.5" />
            </svg>
            <span>{{ address }}</span>
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
              <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" />
            </svg>
            <a [href]="phoneHref">{{ phone }}</a>
          </li>
          <li>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">
              <rect x="3" y="5" width="18" height="14" rx="2" />
              <path d="M3 7l9 6 9-6" />
            </svg>
            <a [href]="emailHref">{{ email }}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="site-footer__bottom">
      <p>{{ 'footer.copyright' | translate: { year: currentYear, brand: ('common.brandName' | translate) } }}</p>
      <p>{{ 'footer.craftedInLisbon' | translate }}</p>
    </div>
  </div>
</footer>
